export default "__VITE_ASSET__CnCb3$48__"